module.exports = __webpack_public_path__ + "img/style_2.95e15b1b.png";